
























import Vue from 'vue';
import { Developer } from '@/types';
import DeveloperChip from '../chips/DeveloperChip.vue';

type Data = {
  model: Developer | null;
  items: Developer[],
  isLoading: boolean,
  search: string | null
}

export default Vue.extend({
  components: {DeveloperChip},
  props: ['value', 'errorMessages'],
  data(): Data {
    return {
      model: null,
      items: [],
      isLoading: false,
      search: null
    };
  },
  computed: {
    selectedId(): number | null {
      return this.value ? Number(this.value) : null;
    }
  },
  watch: {
    search() {
      this.load();
    }
  },
  methods: {
    async load() {
      this.isLoading = true;
      this.$store.api.developers({
        where: {
          search: this.search || undefined
        },
        page: 1,
        perPage: 10
      }).then(res => {
        this.items = res.items;
        if (this.selectedId) {
          return this.$store.api.developer(this.selectedId).then(it => {
            this.items.unshift(it);
          });
        }
      }).catch(this.setError).then(() => { this.isLoading = false; });
    },
    removeSelected() {
      this.$emit('input', null);
    },
    onInput(ev: unknown) {
      this.$emit('input', ev);
    }
  },
  mounted() {
    this.load();
  }
});
